import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IUserTicketState }     from 'Redux/Slices/UserTicket/UserTicketSlice';
import { UserTicket }           from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const findUserTicketRequest = (state: Draft<IUserTicketState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findUserTicketSuccess = (state: Draft<IUserTicketState>, { type, payload }: PayloadAction<{
  userTicket: UserTicket
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = { ...state.entries, [payload.userTicket.id]: payload.userTicket };
};

export const findUserTicketFailure = (state: Draft<IUserTicketState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
